export const COMFORT_STATEMENTS = [
  "You don't have to fix anything today. Just breathing here with me is a massive victory.",
  "This heaviness is not who you are. It is weather passing through you.",
  "You are allowed to rest. Nothing needs to be earned right now.",
  "Your only task in this moment is the next breath. That's enough.",
  "You've survived every hard day so far. You are still here — that matters.",
  "Being gentle with yourself is not giving up. It is a kind of courage.",
  "You don't need words. Just stay. I'm right here with you.",
  "Whatever you're carrying, you can set it down for a moment. It will wait.",
];

// Motivational footer lines filtered by the user's chosen belief lens
export const BELIEF_QUOTES = {
  spiritual: [
    "The wound is the place where the Light enters you. — Rumi",
    "What you seek is seeking you.",
    "The soul usually knows what to do to heal itself. The challenge is to silence the mind.",
  ],
  nature: [
    "Adopt the pace of nature: her secret is patience.",
    "In every walk with nature one receives far more than one seeks. — Muir",
    "The trees that are slow to grow bear the best fruit.",
  ],
  indigenous: [
    "Listen to the wind, it talks. Listen to the silence, it speaks. — Indigenous proverb",
    "We do not inherit the earth from our ancestors; we borrow it from our children.",
    "Walk the Red Road gently — healing moves in a circle, not a line.",
  ],
  scientific: [
    "Naming an emotion reduces its intensity in the brain. You are already helping yourself.",
    "Slow exhales activate the parasympathetic system — your body's calm switch.",
    "Neuroplasticity means your mind can change. Small repeated steps rewire you.",
  ],
  jungian: [
    "Until you make the unconscious conscious, it will direct your life. — Jung",
    "I am not what happened to me, I am what I choose to become. — Jung",
    "Your vision will become clear only when you look into your own heart. — Jung",
  ],
};

export const BELIEF_OPTIONS = [
  { v: "jungian", label: "Jungian wisdom" },
  { v: "spiritual", label: "Spiritual wisdom" },
  { v: "nature", label: "Natural philosophy" },
  { v: "indigenous", label: "Indigenous teachings" },
  { v: "scientific", label: "Scientific psychology" },
];

// Hardcoded priority crisis keyword monitor (bypasses AI)
export const CRISIS_KEYWORDS = [
  "kill myself", "killing myself", "suicide", "suicidal", "end my life", "end it all",
  "want to die", "wanna die", "better off dead", "hurt myself", "harm myself",
  "self harm", "self-harm", "cutting myself", "kill him", "kill her", "kill them",
  "hurt others", "hurt someone", "murder", "no reason to live", "can't go on",
];

export const hasCrisisKeyword = (text = "") => {
  const t = text.toLowerCase();
  return CRISIS_KEYWORDS.some((k) => t.includes(k));
};

export const beliefQuote = (belief) => {
  const list = BELIEF_QUOTES[belief] || BELIEF_QUOTES.jungian;
  return list[Math.floor(Math.random() * list.length)];
};
